import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_financial_paycheck_group_wizard/EditMyCompanyMemberFinancialPaycheckGroupForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import { map } from 'lodash';
import DateTimePicker from '../../components/DateTimePicker';

const EditMyCompanyMemberFinancialPaycheckFutureGroupForm = ({
  handleSubmit,
  submitting,
  localization,
}) => {
  const currency_options = map(localization?.currencies, (currency) => {
    return {
      value: currency.id,
      label: [currency.code, currency.name].join(' - '),
    };
  });

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      {/* <div className={styles.flex}>
        <div className={styles.f1}>
          <label>{__('my_company_members.flyout.current-values')}</label>
        </div>
      </div> */}
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              options={currency_options}
              name='paycheck_currency_id'
              component={Select}
              label={__('my_company_members.flyout.paycheck_currency_future')}
              searchable
            />
          </div>
          <div className={styles.f1} />
          <div className={styles.f1} />
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='brutto_2'
              component={Input}
              label={__('my_company_members.flyout.brutto_2_future')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='brutto_1'
              component={Input}
              label={__('my_company_members.flyout.brutto_1_future')}
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='netto'
              component={Input}
              label={__('my_company_members.flyout.netto_future')}
            />
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='paycheck_start_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.paycheck_start_date_future')}
              footer
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='paycheck_end_date'
              component={DateTimePicker}
              label={__('my_company_members.flyout.paycheck_end_date_future')}
              footer
            />
          </div>
          <div className={styles.f1}></div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_financial_paycheck_group_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_financial_paycheck_group_wizard.edit_my_company_member_financial_paycheck_future_group',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(
        Localization,
        'localization'
      )(EditMyCompanyMemberFinancialPaycheckFutureGroupForm)
    )
  )
);
